/**
 * Comprehensive list of medical specialties and builder utilities.
 */

// Fixed Top 6 most common Specialties displayed initially
export const FIXED_TOP_SPECIALTIES = [
  "Internal Medicine",
  "Family Medicine",
  "Mental Health Counseling",
  "Pediatrics",
  "Psychiatry",
  "Cardiology",
];

// Master specialties list
export const ALL_SPECIALTIES = [
  "Acupuncture",
  "Addiction Counseling",
  "Addiction Medicine",
  "Aerospace Medicine",
  "Allergy and Immunology",
  "Animal-Assisted Therapy",
  "Anesthesiology",
  "Aromatherapy",
  "Art Therapy",
  "Athletic Therapy",
  "Audiology",
  "Ayurveda",
  "Bariatric Medicine",
  "Behavioral Health",
  "Behavioral Health Counseling",
  "Biofeedback Therapy",
  "Case Management",
  "Chiropractic",
  "Child and Adolescent Psychiatry",
  "Clinical Psychology",
  "Clinical Social Work",
  "Cognitive Behavioral Therapy",
  "Critical Care Medicine",
  "Dance/Movement Therapy",
  "Dentistry",
  "Dermatology",
  "Developmental-Behavioral Pediatrics",
  "Dietitian",
  "Drama Therapy",
  "Emergency Medical Services",
  "Emergency Medicine",
  "Endocrinology",
  "Endodontics",
  "Endoscopy",
  "Equine Therapy",
  "Family Therapy",
  "Forensic Medicine",
  "Forensic Psychology",
  "Functional Medicine",
  "Gastroenterology",
  "Genetic Counseling",
  "Genetic Medicine",
  "Geriatrics",
  "Geropsychology",
  "Grief Counseling",
  "Health Psychology",
  "Hematology",
  "Hepatology",
  "Home Services",
  "Homeopathy",
  "Horticultural Therapy",
  "Hospice",
  "Hydrotherapy",
  "Hypnotherapy",
  "Infectious Disease",
  "Integrative Medicine",
  "Internal Medicine & Pediatrics",
  "Lactation Consultant",
  "Marriage and Family Therapy",
  "Massage Therapy",
  "Medical Aesthetics",
  "Music Therapy",
  "Myofunctional Therapy",
  "Naturopathic Doctor",
  "Naturopathy",
  "Neonatology",
  "Nephrology",
  "Neuropsychology",
  "Neurology",
  "Neurosurgery",
  "Nuclear Medicine",
  "Nursing",
  "Nutrition Therapy",
  "Obesity Medicine",
  "Obstetrics and Gynecology",
  "Occupational Medicine",
  "Occupational Therapy",
  "Oncology",
  "Ophthalmology",
  "Optometry",
  "Oral and Maxillofacial Surgery",
  "Orthodontics",
  "Orthopedic Surgery",
  "Orthotics & Prosthetics",
  "Osteopathic Doctor",
  "Otolaryngology",
  "Palliative Care",
  "Pain Management",
  "Pathology",
  "Pediatric Cardiology",
  "Pediatric Endocrinology",
  "Pediatric Gastroenterology",
  "Pediatric Nephrology",
  "Pediatric Neurology",
  "Pediatric Oncology",
  "Pediatric Pulmonology",
  "Pediatric Psychology",
  "Pediatric Surgery",
  "Pharmacy",
  "Physical Medicine and Rehabilitation",
  "Physical Therapy",
  "Plastic Surgery",
  "Play Therapy",
  "Podiatry",
  "Primary Care",
  "Psychotherapy",
  "Pulmonology",
  "Radiation Therapy",
  "Radiology",
  "Recreational Therapy",
  "Reflexology",
  "Rehabilitation Psychology",
  "Reiki",
  "Respiratory Therapy",
  "Rheumatology",
  "School Psychology",
  "Sleep Medicine",
  "Speech-Language Pathology",
  "Sports Medicine",
  "Sports Psychology",
  "Student",
  "Substance Abuse Counseling",
  "Surgery",
  "Traditional Chinese Medicine",
  "Trauma Surgery",
  "Transplant Surgery",
  "Urology",
  "Urgent Care",
  "Vascular Surgery",
  "Veterinary",
  "Wellness Coordinator",
  "Women's Medicine",
  "Wound Care",
  "Yoga Therapy",
  "Other",
];

/**
 * Builds the default list of specialty options with the Fixed Top 6 at the beginning,
 * followed by all other specialties sorted alphabetically, and "Other" at the end.
 */
export function buildSpecialtyOptions(extraOptions = []) {
  const fixedSet = new Set(FIXED_TOP_SPECIALTIES.map((s) => s.toLowerCase()));
  const extraList = Array.isArray(extraOptions) ? extraOptions : [];

  const restSet = new Set();
  const restList = [];

  [...ALL_SPECIALTIES, ...extraList].forEach((opt) => {
    const val = typeof opt === "string" ? opt.trim() : (opt?.value || opt?.label || "").trim();
    if (!val) return;
    const lower = val.toLowerCase();
    if (fixedSet.has(lower) || lower === "other") return;
    if (!restSet.has(lower)) {
      restSet.add(lower);
      restList.push(val);
    }
  });

  restList.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  return [...FIXED_TOP_SPECIALTIES, ...restList, "Other"];
}
